import { sortBy } from 'lodash';
import { INVITE_STATUSES } from 'app/developer-v3/constants';

import type { Members } from 'app/developer-v3/types/member';

export const sortMembers = (members: Members) =>
  sortBy(members, [
    member => (member.status === INVITE_STATUSES.accepted ? -1 : 1),
    member => member.name || member.email,
  ]);
